export const TAX_RATE = 0.02;
export const BROKER_RATE = 0.015;
export const APPRAISAL_FEE = 650;
export const MORTGAGE_ADVICE_FEE = 1695;
export const NOTARY_FEE = 1500;
